import { Component, Injectable, OnInit } from '@angular/core';

import { AppOfflineDialogComponent } from './shared/app-offline-dialog/app-offline-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxEchartsDirective, provideEcharts } from 'ngx-echarts';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpProgressEvent,
  HttpEventType,
  HttpResponse,
} from "@angular/common/http";
import { Observable, of, concat } from "rxjs";
import { delay } from "rxjs/operators";
import { CommonModule } from '@angular/common';
import { Router, Data, RoutesRecognized } from '@angular/router';

export enum Layouts {
  FooterOnly,
  Main
}

@Component({
  selector: 'sdc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  //imports: [CommonModule, NgxEchartsDirective],
})
export class AppComponent implements OnInit {
  globalLookup: null;
  title = 'SoftDiamond';
  isLoading = true;
  Layouts = Layouts
  layout: Layouts;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer) {

    this.matIconRegistry.addSvgIcon('add_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/add_blue.svg'));
    this.matIconRegistry.addSvgIcon('add_green', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/add_green.svg'));
    this.matIconRegistry.addSvgIcon('add_grey', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/add_grey.svg'));
    this.matIconRegistry.addSvgIcon('add_white', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/add_white.svg'));
    this.matIconRegistry.addSvgIcon('billing_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/billing_blue.svg'));
    this.matIconRegistry.addSvgIcon('calendar', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/calendar.svg'));
    this.matIconRegistry.addSvgIcon('delete_red', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/delete_red.svg'));
    this.matIconRegistry.addSvgIcon('edit_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/edit_blue.svg'));
    this.matIconRegistry.addSvgIcon('organisations_blue', this.domSanitizer
      .bypassSecurityTrustResourceUrl('../assets/images/organisations_blue.svg'));
    this.matIconRegistry.addSvgIcon('organisations_white', this.domSanitizer
      .bypassSecurityTrustResourceUrl('../assets/images/organisations_white.svg'));
    this.matIconRegistry.addSvgIcon('people_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/people_blue.svg'));
    this.matIconRegistry.addSvgIcon('people_white', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/people_white.svg'));
    this.matIconRegistry.addSvgIcon('properties_blue', this.domSanitizer
      .bypassSecurityTrustResourceUrl('../assets/images/properties_blue.svg'));
    this.matIconRegistry.addSvgIcon('properties_white', this.domSanitizer
      .bypassSecurityTrustResourceUrl('../assets/images/properties_white.svg'));
    this.matIconRegistry.addSvgIcon('search_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/search_blue.svg'));
    this.matIconRegistry.addSvgIcon('search_grey', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/search_grey.svg'));
    this.matIconRegistry.addSvgIcon('search_white', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/search_white.svg'));
    this.matIconRegistry.addSvgIcon('tick_green', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/tick_green.svg'));
    this.matIconRegistry.addSvgIcon('left_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/left_blue.svg'));
    this.matIconRegistry.addSvgIcon('right_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/right_blue.svg'));
    this.matIconRegistry.addSvgIcon('down_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/down_blue.svg'));
    this.matIconRegistry.addSvgIcon('up_blue', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/up_blue.svg'));
    this.matIconRegistry.addSvgIcon('left_grey', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/left_grey.svg'));
    this.matIconRegistry.addSvgIcon('right_grey', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/right_grey.svg'));
    this.matIconRegistry.addSvgIcon('down_grey', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/down_grey.svg'));
    this.matIconRegistry.addSvgIcon('up_grey', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/up_grey.svg'));
    this.matIconRegistry.addSvgIcon('error_red', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/error_red.svg'));

  }

  showAppOfflineDialog(): void {
    const dialogRef = this.dialog.open(AppOfflineDialogComponent, { disableClose: true });
    dialogRef.afterClosed().subscribe({
      next: result => {
        //Force the user to logout as their account won't have been created in the database if it is their first login
        //this.authService.logout();
      }
    });
  }

  ngOnInit(): void {
    /* this.lookupCacheService.getLookups().subscribe(
      globalLookup => {
        this.globalLookup = globalLookup;
        this.isLoading = false;
      }
    ); */
    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        this.layout = data.state.root.firstChild.data.layout;
      console.log(this.layout);
      console.log(this.Layouts);
      }
    });
  }
}

@Injectable()
export class UploadInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.url === "saveUrl") {
      const events: Observable<HttpEvent<unknown>>[] = [0, 30, 60, 100].map(
        (x) =>
          of(<HttpProgressEvent>{
            type: HttpEventType.UploadProgress,
            loaded: x,
            total: 100,
          }).pipe(delay(1000))
      );

      const success = of(new HttpResponse({ status: 200 })).pipe(delay(1000));
      events.push(success);

      return concat(...events);
    }

    if (req.url === "removeUrl") {
      return of(new HttpResponse({ status: 200 }));
    }

    return next.handle(req);
  }
}
